import { ArrowDownIcon } from 'lucide-react';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

import { BatchLTLShipmentStatus } from './types';
import { BatchLTLStatusCounts } from './utils/batchLTLSummary';

type BatchLTLSummaryBarProps = {
  counts: BatchLTLStatusCounts;
  onJumpToReply: () => void;
};

// "5 rated · 1 no rates · 1 needs info" once rating has started; "5 in reply" after the reply.
export function BatchLTLSummaryBar({
  counts,
  onJumpToReply,
}: BatchLTLSummaryBarProps) {
  const parts = [
    {
      count: counts[BatchLTLShipmentStatus.InReply],
      label: 'in reply',
      isProblem: false,
    },
    {
      count: counts[BatchLTLShipmentStatus.Rated],
      label: 'rated',
      isProblem: false,
    },
    {
      count: counts[BatchLTLShipmentStatus.Rating],
      label: 'rating',
      isProblem: false,
    },
    {
      count: counts[BatchLTLShipmentStatus.Failed],
      label: 'no rates',
      isProblem: true,
    },
    {
      count: counts[BatchLTLShipmentStatus.Invalid],
      label: 'needs info',
      isProblem: true,
    },
  ].filter(({ count }) => count > 0);

  return (
    <Flex
      align='center'
      gap='sm'
      className='w-full rounded border border-neutral-200 bg-neutral-100 px-2.5 py-1.5'
      data-testid='batch-ltl-summary'
    >
      <Typography variant='body-xs' as='span'>
        {parts.map(({ count, label, isProblem }, index) => (
          <Typography
            key={label}
            variant='body-xs'
            weight={index === 0 ? 'semibold' : 'normal'}
            textColor={isProblem ? 'error' : 'default'}
            as='span'
          >
            {index > 0 && ' · '}
            {`${count} ${label}`}
          </Typography>
        ))}
      </Typography>
      <button
        type='button'
        className='ml-auto flex items-center gap-0.5 text-xs font-medium text-neutral-800 hover:underline'
        onClick={onJumpToReply}
      >
        Reply
        <ArrowDownIcon className='h-3 w-3' />
      </button>
    </Flex>
  );
}
